/*
**  slideshow -- Observe and Control Slideshow Applications
**  Copyright (c) 2014-2015 Ralf S. Engelschall <http://engelschall.com>
**
**  This Source Code Form is subject to the terms of the Mozilla Public
**  License (MPL), version 2.0. If a copy of the MPL was not distributed
**  with this file, You can obtain one at http://mozilla.org/MPL/2.0/.
**
**  File:     connector.js
**  Purpose:  low-level connector
**  Language: Node/JavaScript
*/

/*  thid-party requirements  */
var os       = window.require("os");
var path     = require("path");
var spawn    = window.require("child_process").spawn;
var es       = require("event-stream");
var Promise  = require("bluebird");



/*  the supported connectors  */
var connectors = {
    "darwin-keynote":        "connector-osx-kn5.sh",
    "darwin-keynote5":       "connector-osx-kn5.sh",
    "darwin-keynote6":       "connector-osx-kn6.sh",
    "darwin-powerpoint":     "connector-osx-ppt2011.sh",
    "darwin-powerpoint2011": "connector-osx-ppt2011.sh",
    "darwin-powerpoint2016": "connector-osx-ppt2011.sh",
    "win32-powerpoint":      "connector-win-ppt2010.bat",
    "win32-powerpoint2010":  "connector-win-ppt2010.bat",
    "win32-powerpoint2013":  "connector-win-ppt2010.bat"
};

/*  the connector API constructor  */
var connector = function (application) {
    /*  determine connector filename  */
    var id = os.platform() + "-" + application;
    var cn = connectors[id];
    if (typeof cn === "undefined")
        throw new Error("unsupported platform/application combination: " + id);
    var filename = cn;

    console.log('production? ', process.env.REACT_APP_PRODUCTION )
    if( process.env.REACT_APP_PRODUCTION===true || process.env.REACT_APP_PRODUCTION==="true" ) {
        /*Esto es lo que va cuando se genere */
        var path = window.require('path');
        filename = path.join(window.__dirname, ".." ,"appleScripts/"+filename).replace('app.asar', 'app.asar.unpacked');
    }
    else{
        const electron = window.require('electron');
        const path = electron.remote.require('path');
        console.log('__dirname ', window.__dirname)

        if ( os.platform() === 'darwin' ){
            filename = path.join(window.__dirname, "../../../../../../../../public" ,"appleScripts/"+filename).replace('app.asar', 'app.asar.unpacked');
        }
        else{
            
            filename = path.join(window.__dirname, "../../../../../../public" ,"appleScripts/"+filename).replace('app.asar', 'app.asar.unpacked');
        }
        
    }

    console.log( "process", filename )

    //console.log( process.env.PATH );
    /*  spawn the connector as a child process  */
    this.c = spawn( '"' + filename + '"', [], {
        stdio: [ "pipe", "pipe", window.process.stderr ],
        env: {"ATOM_SHELL_INTERNAL_RUN_AS_NODE":"0"},
        shell: true
    });

    /*  set the stdin/stdout pipes to UTF-8 encoding mode  */
    this.c.stdin.setEncoding("utf8");
    this.c.stdout.setEncoding("utf8");

    /*  create line-based duplex stream out of stdin/stdout piples  */
    this.io = es.duplex(
        this.c.stdin,
        this.c.stdout.pipe(es.split(/\r?\n/))
    );

    /*  connect to the stream for capturing responses  */
    this.responses = [];
    this.callbackStat = null;
    this.callbackError = null;
    this.callbackInfo = null;
    this.callbackImgToglea = null;
    this.callbackTempPath = null;
    this.stateReceived = true;
    var _connector = this;
    this.io.pipe(es.through( function(data){ _connector.onData(data)} ) );
};

/*  the connector API methods  */
connector.prototype = {
    request: function (request) {
        //console.log('request ' + request)
        var scope = this;
        var promise = new Promise( function(resolve, reject) {
            scope.responses.push(function (response) {
                try {
                    response = JSON.parse(response);
                }
                catch (ex) {
                    reject("Invalid response type from connector: " + ex);
                }
                if (typeof response.error === "string")
                    reject(response.error);
                else if (typeof response.response !== "undefined")
                    resolve(response.response);
                else
                    reject("Invalid response structure from connector");
            });
            scope.io.write(JSON.stringify(request) + "\r\n");
        });
    },
    end: function () {
        this.io.end();
    },

    onData: function( data ){
        console.log('data', data,"error?",data.error,data.error!==undefined)
        if (typeof data === "undefined" || data === "")
            return;

        if(data.error !== undefined) {
            window.platformHandler.showGeneralError("Lo sentimos, se ha presentado un error al comunicarse con PowerPoint, por favor cierre ambas aplicaciones e intente de nuevo, en caso de persistir el problema contacte a support@flipwit.com para solucionar el inconveniente.");
            return;
        }


        //remueve el %0B que provoca problemas al decodificar
        data = data.replace(new RegExp("%0B", 'g'), "");
        data = data.replace(new RegExp("%09", 'g'), "");
        if( os.platform() != "darwin"){            
            data = decodeURIComponent( data );
        }


        data = data.replace(new RegExp("\r", 'g'), "\\r");
        //}
        //console.log("data ded: ", data);
        let jsonResponse

        try{
            jsonResponse = JSON.parse(data);
        }
        catch( e ){
            console.log('Falla con Data a parsear es',data);
            console.log('ERROR trying to parse data connector',e.stack);
            if( this.callbackError != null ){
                this.callbackError( data );
            }
            this.stateReceived = true;
            return;
        }
        if( jsonResponse.cmd != undefined ){
            switch( jsonResponse.cmd ){
                case "INFO":
                            this.request({ command: "HIDE" });
                            if( this.callbackInfo != null ){
                                this.callbackInfo(jsonResponse);
                            }
                    break;

                case "EXPORT":
                case "CONT_EXPORT":
                            if( this.callbackExport != null ){
                                this.callbackExport(jsonResponse);
                            }
                    break;


                case "TEMPPATH": if( this.callbackTempPath != null ){
                                    this.callbackTempPath( jsonResponse.path );
                                }
                                break;

                case "STAT": this.stateReceived = true;
                            if( this.callbackStat != null ){
                                this.callbackStat(jsonResponse);
                            }
                    break;

                case "IMGTOGLEA":
                            if( this.callbackImgToglea != null ){
                                this.callbackImgToglea(jsonResponse);
                            }
                            break;
                case "NEWACT": console.log("data new Act: " + data);
                    break;

                case "START": console.log("data start: " + data);
                break;

                case "ACTIVATE": console.log("data activate: " + data);
                break;

                default: console.log('defaul ' + data);
            }
        }

    }
};

/*  export the API  */
module.exports = connector;



// WEBPACK FOOTER //
// ./src/containers/platforms/electron/js/powerpoint/mac/api/connector.js